import { render, staticRenderFns } from "./Lottery.vue?vue&type=template&id=0ca5a7bd&"
import script from "./Lottery.vue?vue&type=script&lang=ts&"
export * from "./Lottery.vue?vue&type=script&lang=ts&"
import style0 from "./Lottery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Lottery.vue"
export default component.exports